import { Ref, forwardRef, useEffect, useState } from 'react';
import clsx from 'clsx';
import Button, { ButtonPropsExt } from '../button/Button';

export interface TextButtonProps extends ButtonPropsExt {
  caption: string;
  className?: string;
}

const TextButtonComponent: React.ForwardRefRenderFunction<
  HTMLButtonElement,
  TextButtonProps
> = (props: TextButtonProps, ref: Ref<HTMLButtonElement>) => {
  const [tooltip, setTooltip] = useState<string>('');
  useEffect(() => {
    const newTooltip =
      props.tooltip && props.tooltip.length > 0 ? props.tooltip : props.caption;
    setTooltip(newTooltip);
  }, [props.caption, props.tooltip]);

  return (
    <Button
      ref={ref}
      className={clsx(props.className)}
      tooltip={tooltip}
      disabled={props.disabled}
      onClick={props.onClick}
      buttonType={props.buttonType}
    >
      <div style={{ overflow: 'hidden' }}>{props.caption}</div>
    </Button>
  );
};

const TextButton = forwardRef(TextButtonComponent);

export default TextButton;
